/* eslint-disable */
$(function(){

    $('.remove-article').click(function(){
        $(this).closest('article').hide();
    });

});
